import {Tooltip} from "primereact/tooltip";
import {useTranslation} from "react-i18next";

import {selectUsername} from "../redux/authSlice";
import {useRevaSelector} from "../redux/revaHooks";

function MissingPermissionTooltipContent() {
    const {t} = useTranslation();
    const username = useRevaSelector(selectUsername);

    return (
        <>
            <div className="mx-4 mt-2 mb-6 text-xl">
                <span className="pi pi-lock text-xl mr-4"></span>
                {t("general.missingPermissionTitle")}
            </div>
            <p className="m-4">
                {t("general.missingPermission1")}
                <strong>{username}</strong>
                {t("general.missingPermission2")}
            </p>
            <p className="m-4 mt-0">
                {t("general.missingPermissionContact")}
                <a
                    href="https://www.value-marktdaten.de/contact"
                    target="_blank"
                    rel="noreferrer"
                    style={{color: "inherit"}}
                    className="p-button-label ml-2"
                >
                    {t("general.contact")}
                </a>
            </p>
        </>
    );
}

interface MissingPermissionTooltipProps {
    target: string;
    position?: "top" | "bottom" | "left" | "right" | "mouse";
    appendTo?: HTMLElement | null;
}

function MissingPermissionTooltip({target, position, appendTo}: MissingPermissionTooltipProps) {
    const effectiveAppendTo = appendTo ?? (document.getElementsByClassName("App").item(0) as HTMLElement | null);
    return (
        <Tooltip
            target={target}
            position={position}
            autoHide={false}
            className="warnTooltip"
            appendTo={effectiveAppendTo}
        >
            <MissingPermissionTooltipContent />
        </Tooltip>
    );
}

export default MissingPermissionTooltip;
